import { render, staticRenderFns } from "./Journal_transaction.vue?vue&type=template&id=05b3055c&"
import script from "./Journal_transaction.vue?vue&type=script&lang=js&"
export * from "./Journal_transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports